<script lang="ts">
  import PageWrapper from "@src/components/PageWrapper.svelte";
  import Row from "@src/components/Row.svelte";
  import PinnedTripsSection from "./PinnedTripsSection.svelte";
</script>

<svelte:head>
  <title>Niilon Pojat</title>
</svelte:head>
<PageWrapper fillerColor="gray">
  <Row color="yellow">
    <h1>Seuraavat matkat</h1>
    <PinnedTripsSection />
  </Row>
  <Row color="gray" filler />
</PageWrapper>
